import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ERROR_TEXTS } from "../../constants/texts";
import { PAYMENT_SUBJECT_CONFIG } from "../../constants/payment";
import { checkBeelineRequest } from "../../api/requests/checkBeelineRequest";
import { findFirst } from "../../utils/arrays";
import { checkIsClientSide } from "../../_shared/utils/ym";
import { EPaymentConstant } from "../../utils/constants";
var composePaymentUrl = function composePaymentUrl(userType, ctn, sum) {
  return "/customers/how-to-pay/popolnenie-scheta/#/ImmediatePayment/".concat(userType, "/?ctn=").concat(ctn, "&sum=").concat(sum);
};

/**
 * @desc: редирект на страницу оплаты
 * @param param { ctn: string, sum: string, type: string } ctn, передавать без маски
 */
export var redirectToPayment = function redirectToPayment(_ref) {
  var ctn = _ref.ctn,
    sum = _ref.sum,
    type = _ref.type,
    isAuth = _ref.isAuth;
  if (!checkIsClientSide()) return;
  var userType = type === PAYMENT_SUBJECT_CONFIG.internet.id ? 'Fttb' : 'Mobile';
  var sumAmount = Number(sum);
  var _sum = !Number.isNaN(sumAmount) ? sumAmount.toFixed(0) : '';
  var url = findFirst([isAuth && composePaymentUrl(userType, ctn, _sum), '/login']);

  /** NOTE: https://stackoverflow.com/a/70463940 */
  setTimeout(function () {
    return window.open(url, '_blank');
  });
};

/**
 * @desc: валидирует ctn и возвращает ошибку, если что-то не так
 * @param ctn { string }
 * @param paymentSubject { string } за что оплата (интернет || телефон)
 * @param paymentSubjectConfig { object }
 * @returns {string}
 */
export var getCtnError = function getCtnError(_ref2) {
  var _paymentSubjectConfig, _paymentSubjectConfig2;
  var ctn = _ref2.ctn,
    paymentSubject = _ref2.paymentSubject,
    paymentSubjectConfig = _ref2.paymentSubjectConfig;
  if (!ctn) {
    return ERROR_TEXTS.required;
  }
  if (paymentSubject === (paymentSubjectConfig === null || paymentSubjectConfig === void 0 || (_paymentSubjectConfig = paymentSubjectConfig.cellphone) === null || _paymentSubjectConfig === void 0 ? void 0 : _paymentSubjectConfig.id) && ctn.length !== 10) {
    return ERROR_TEXTS.invalidPhone;
  }
  if (paymentSubject === (paymentSubjectConfig === null || paymentSubjectConfig === void 0 || (_paymentSubjectConfig2 = paymentSubjectConfig.internet) === null || _paymentSubjectConfig2 === void 0 ? void 0 : _paymentSubjectConfig2.id) && ctn.length !== 10) {
    return ERROR_TEXTS.invalidAccountNumber;
  }
  return '';
};

/**
 * @desc: является ли пользователь абонентом билайн
 * @param widgetPayUrl {string}
 * @param ctn {string}
 * @returns {Promise<{valid: boolean, fetchError: boolean}>}
 */
export var checkCtn = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
    var widgetPayUrl, ctn, isSuccess;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          widgetPayUrl = _ref3.widgetPayUrl, ctn = _ref3.ctn;
          _context.prev = 1;
          _context.next = 4;
          return checkBeelineRequest(widgetPayUrl, ctn);
        case 4:
          isSuccess = _context.sent;
          return _context.abrupt("return", {
            valid: isSuccess,
            fetchError: !isSuccess
          });
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](1);
          console.error(_context.t0);
          return _context.abrupt("return", {
            valid: true,
            fetchError: false
          });
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 8]]);
  }));
  return function checkCtn(_x) {
    return _ref4.apply(this, arguments);
  };
}();
export var deleteQueryParam = function deleteQueryParam(param) {
  var query = new URLSearchParams(window.location.search);
  query.delete(param);
  var search = query.toString();
  if (search.length > 0) {
    search = "?".concat(search);
  }
  window.history.replaceState(null, document.title, window.location.pathname + search);
};
var processTrailingCases = function processTrailingCases(sum) {
  return sum.replace(/\./g, ',').replace(/,00/g, '');
};
export var kopeikiToRubles = function kopeikiToRubles(rubles) {
  return processTrailingCases((rubles / EPaymentConstant.KopeikiPerRuble).toFixed(2));
};
export var composeInputPlaceholder = function composeInputPlaceholder(_ref5) {
  var min = _ref5.min,
    max = _ref5.max;
  return findFirst([!(min && max) && 'Введите сумму', "".concat(kopeikiToRubles(min), "\u2013").concat(kopeikiToRubles(max), " \u20BD \u0431\u0435\u0437 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0438")]);
};